import cx from 'classnames'
import DetailTableHeader from 'component/CFSPage/DetailTableHeader'
import detailPageStyle from 'component/detailPageStyle'
import CheckBoxInput from 'component/field/CheckBoxInput'
import SelectInput from 'component/field/SelectInput'
import TextInput from 'component/field/TextInput'
import BoxFullWidth from 'component/material/BoxFullWidth'
import CustomTooltip from 'component/material/CustomTooltip'
import GridContainer from 'component/material/GridContainer'
import GridItem from 'component/material/GridItem'
import PrimaryButton from 'component/material/PrimaryButton'
import Table from 'component/material/table/Table'
import {CZ_DPH, DATE_FORMAT, DB_DATE_FORMAT, SK_DPH} from 'helper/constants'
import {fireErrorToast, mapErrorResponseToForm, redirectTo} from 'helper/functions'
import {composeValidators, maxDate, minDate, required, validateVin} from 'helper/validations'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {Field, Form} from 'react-final-form'
import {connect} from 'react-redux'
import {useParams} from 'react-router-dom'
import {bindActionCreators, compose} from 'redux'
import {
  createCfs,
  getAttachments,
  getCar,
  getCfs,
  getMyFleets,
  getMySuppliers,
  getPredefinedTerms,
  patchCfs,
} from 'redux/action/cfsAction'
import {ReactComponent as Bin} from 'style/asset/bin.svg'
import {Trans} from '@lingui/macro'
import {IconButton} from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'

const CFSDetail = (props) => {
  const {
    classes,
    getCfs,
    cfs,
    cfsLoading,
    patchCfs,
    createCfs,
    mySupplier,
    mySupplierLoading,
    getMySuppliers,
    getMyFleets,
    myFleets,
    myFleetsLoading,
    getCar,
    carLoading,
    car,
    getAttachments,
    attachmentTypes,
    attachmentTypesLoading,
    getPredefinedTerms,
    predefinedTerms,
    predefinedTermsLoading,
  } = props

  let {id} = useParams()

  const [workItems, setWorkItems] = useState([])
  const [materialItems, setMaterialItems] = useState([])
  const [predefinedItems, setPredefinedItems] = useState([])
  const [editedValues, setEditedValues] = useState({})
  const [focusedRow, setFocusedRow] = useState()
  const [carFilters, setCarFilters] = useState({})
  const [fileList, setFileList] = useState([])

  const isSkProvider = mySupplier?.provider?.id === 3 || mySupplier?.provider?.id === 4

  const handleSetFocusedRow = (itemRow) => {
    setFocusedRow(itemRow)
  }

  const handleFieldChange = (e) => {
    const name = e.target.name

    if (e.target.type === 'checkbox') {
      setEditedValues((prevState) => ({...prevState, [name]: e.target.checked}))
    } else {
      setEditedValues((prevState) => ({...prevState, [name]: e.target.value}))
    }

    if (name === 'fleet_id') {
      getPredefinedTerms(e.target.value)
    }
  }

  const handleItemChange = (type, index, e, materialType) => {
    const name = e.target.name.split('.')[e.target.name.split('.').length - 1]
    let value = e.target.value

    if (typeof value === 'string') {
      value = value.replace(',', '.')
    }

    if (name === 'discount' && value < 0) {
      value = Math.abs(value)
    }

    if (name === 'unit_price' || name === 'quantity') {
      value = Math.abs(value)
    }

    if (type === 'work') {
      let newWorkItems = [...workItems]
      newWorkItems[index] = {...workItems[index], [name]: value}
      setWorkItems(newWorkItems)
    } else if (type === 'material') {
      const otherMaterials = [...materialItems].filter(
        (items) => items.line_type?.code !== materialType && items.line_type_code !== materialType
      )

      const newMaterial = [...materialItems].filter(
        (items) => items.line_type?.code === materialType || items.line_type_code === materialType
      )

      newMaterial[index] = {...newMaterial[index], [name]: value}

      setMaterialItems([...newMaterial, ...otherMaterials])
    } else if (type === 'predefined') {
      const selectedTerm = predefinedTerms?.find((term) => term?.description === value)

      if (name === 'description') {
        let newPredefined = [...predefinedItems]
        newPredefined[index] = {
          ...predefinedItems[index],
          description: selectedTerm?.description,
          unit_price: selectedTerm?.price,
          code: selectedTerm?.code,
        }
        setPredefinedItems(newPredefined)
      } else {
        let newPredefined = [...predefinedItems]
        newPredefined[index] = {...predefinedItems[index], [name]: value}
        setPredefinedItems(newPredefined)
      }
    }
  }

  const prepareValues = (values) => {
    return {
      status_id: Number(values.status),
      status_description: values.new_status_description ? values.new_status_description : null,
      date_due: values.date_due && moment(values.date_due, DATE_FORMAT).format(DB_DATE_FORMAT),
      date_issue:
        values.date_issue && moment(values.date_issue, DATE_FORMAT).format(DB_DATE_FORMAT),
      date_uzp: values.date_uzp && moment(values.date_uzp, DATE_FORMAT).format(DB_DATE_FORMAT),
      items: [...workItems, ...materialItems, ...predefinedItems].map((item) => {
        const itemType = item.line_type_code ? item.line_type_code : item.line_type?.code
        const itemId = item.id.toString().includes('NEW') ? null : item.id
        delete item.line_type
        return {
          ...item,
          line_type_code: itemType,
          id: itemId,
          quantity: Number(item.quantity),
          tax: Number(item.tax),
          unit_price: Number(item.unit_price),
          discount: Number(item.discount),
        }
      }),
      fleet_id: values.fleet_id,
      tax_document_no: values.tax_document_no,
      order_no: values.order_no,
      confirmation_no: values.confirmation_no,
      attachments: [...fileList],
      clock: values.clock,
      insured_event: values.insured_event ? values.insured_event : false,
      loan_vehicle: values.loan_vehicle ? values.loan_vehicle : false,
      vehicle: values.vehicle,
      car: values.is_without_car
        ? null
        : {
            rz: values.rz,
            vin: values.vin,
            id: editedValues.car_id ? editedValues.car_id : values.car?.id ? values.car.id : null,
          },
    }
  }

  const enhanceError = (error) => {
    if (error) {
      const newError = [...error]
      return newError.map((err) => {
        if (err.source.includes('.')) {
          return {...err, source: err.source.split('.')?.[1]}
        } else {
          return err
        }
      })
    }
  }

  const handleSubmit = (values) => {
    const preparedValues = prepareValues(values)

    // vyfiltruj prilohu zakazkovy list
    const hasOrderAttachment = preparedValues.attachments.filter((att) => att.type_id === 1)

    if (id === 'new') {
      if (hasOrderAttachment?.length) {
        return createCfs(preparedValues)
          .then(() => {
            redirectTo('/invoices')
          })
          .catch((err) => {
            const error = enhanceError(err)
            return mapErrorResponseToForm(error)
          })
      } else {
        fireErrorToast(<Trans>There must be at least one order attachment</Trans>)
      }
    } else {
      return patchCfs(id, preparedValues)
        .then((res) => {
          getCfs(id).then((res) => {
            setWorkItems(res?.items?.filter((item) => item?.line_type?.code === 'WORK'))

            setMaterialItems([
              ...res?.items?.filter((item) => item?.line_type?.code === 'GOOD'),
              ...res?.items?.filter((item) => item?.line_type?.code === 'ELIT'),
              ...res?.items?.filter((item) => item?.line_type?.code === 'OE'),
            ])

            setPredefinedItems(res?.items?.filter((item) => item?.line_type?.code === 'PREDEFINED'))
          })
        })
        .catch((err) => {
          const error = enhanceError(err)
          return mapErrorResponseToForm(error)
        })
    }
  }

  const getInitialValues = () => {
    if (id === 'new') {
      return {
        provider: {
          name: mySupplier?.provider?.name ? mySupplier?.provider?.name : null,
          ic: mySupplier?.provider?.ic ? mySupplier?.provider?.ic : null,
        },
        supplier_customer_no: mySupplier ? mySupplier.customer_no : null,
        supplier_ic: mySupplier ? mySupplier.ic : null,
        ...editedValues,
        workItem: workItems,
        goodItem: materialItems?.filter(
          (item) => item?.line_type?.code === 'GOOD' || item?.line_type_code === 'GOOD'
        ),
        elitItem: materialItems?.filter(
          (item) => item?.line_type?.code === 'ELIT' || item?.line_type_code === 'ELIT'
        ),
        oeItem: materialItems?.filter(
          (item) => item?.line_type?.code === 'OE' || item?.line_type_code === 'OE'
        ),
        predefinedItem: predefinedItems,
      }
    } else {
      return {
        provider: {
          name: mySupplier?.provider?.name ? mySupplier?.provider?.name : null,
          ic: mySupplier?.provider?.ic ? mySupplier?.provider?.ic : null,
        },
        ...cfs,
        date_issue: cfs.date_issue
          ? moment(cfs.date_issue, DB_DATE_FORMAT).format(DATE_FORMAT)
          : null,
        date_due: cfs.date_due ? moment(cfs.date_due, DB_DATE_FORMAT).format(DATE_FORMAT) : null,
        date_uzp: cfs.date_uzp ? moment(cfs.date_uzp, DB_DATE_FORMAT).format(DATE_FORMAT) : null,
        status_description_copy: cfs.status_description,
        workItem: workItems,
        goodItem: materialItems?.filter(
          (item) => item?.line_type?.code === 'GOOD' || item?.line_type_code === 'GOOD'
        ),
        elitItem: materialItems?.filter(
          (item) => item?.line_type?.code === 'ELIT' || item?.line_type_code === 'ELIT'
        ),
        oeItem: materialItems?.filter(
          (item) => item?.line_type?.code === 'OE' || item?.line_type_code === 'OE'
        ),
        predefinedItem: predefinedItems,
        supplier_customer_no: mySupplier ? mySupplier.customer_no : null,
        supplier_ic: mySupplier ? mySupplier.ic : null,
        fleet_id: cfs?.car?.fleet_id ? cfs?.car?.fleet_id : null,
        // fill car base on response
        ...editedValues,
        rz:
          editedValues?.rz || editedValues?.rz === ''
            ? editedValues?.rz
            : cfs?.car?.rz
            ? cfs.car.rz
            : null,
        vin:
          editedValues?.vin || editedValues?.vin === ''
            ? editedValues?.vin
            : cfs?.car?.vin
            ? cfs.car.vin
            : null,
        vehicle: car?.model_desc
          ? car.model_desc
          : editedValues?.vehicle || editedValues?.vehicle === ''
          ? editedValues?.vehicle
          : cfs?.vehicle
          ? cfs.vehicle
          : null,
      }
    }
  }

  const getPriceWithoutTax = (item) => {
    if (item) {
      const discount = !item.discount ? 1 : (100 - Number(item.discount)) / 100
      const unitPrice = !item?.unit_price ? 0 : Number(item?.unit_price)
      const quantity = !item?.quantity ? 0 : Number(item?.quantity)
      return Math.round(unitPrice * quantity * discount * 100) / 100
    } else {
      return 0
    }
  }

  const getTotal = (values, withTax = false) => {
    const allItems = []
    if (values) {
      values.workItem && allItems.push(...values.workItem)
      values.goodItem && allItems.push(...values.goodItem)
      values.elitItem && allItems.push(...values.elitItem)
      values.oeItem && allItems.push(...values.oeItem)
      values.predefinedItem && allItems.push(...values.predefinedItem)

      if (withTax) {
        return allItems.reduce(
          (prev, curr) =>
            prev +
            (!curr?.unit_price ? 0 : Number(curr?.unit_price)) *
              (!curr?.quantity ? 0 : Number(curr?.quantity)) *
              (!curr.discount ? 1 : (100 - Number(curr.discount)) / 100) *
              ((100 + Number(curr.tax)) / 100),
          0
        )
      } else {
        return allItems.reduce(
          (prev, curr) =>
            prev +
            (!curr?.unit_price ? 0 : Number(curr?.unit_price)) *
              (!curr?.quantity ? 0 : Number(curr?.quantity)) *
              (!curr.discount ? 1 : (100 - Number(curr.discount)) / 100),
          0
        )
      }
    } else {
      return 0
    }
  }

  const attachmentColumns = [
    {
      name: 'file_name',
      label: <Trans>Name</Trans>,
      render: (val, row) => (
        <a
          href={row.file_uri}
          target={'_blank'}
          title="Stáhnout"
          download
          className={cx(row.file_uri && classes.downloadLink)}
        >
          {val}
        </a>
      ),
    },
    {
      name: 'type',
      label: <Trans>Type</Trans>,
      render: (val) => val?.name,
    },
  ]

  const handleAddItem = (type, dateIssue) => () => {
    const hasSKNewDPH = dateIssue && moment(dateIssue, DATE_FORMAT).isAfter('2024-12-31')

    if (type === 'work') {
      setWorkItems((prevState) => [
        ...prevState,
        {
          id: `NEW-WORK-${Math.random()}`,
          code: '',
          description: '',
          unit_price: 0,
          quantity: 0,
          tax: isSkProvider ? (hasSKNewDPH ? 23 : 20) : 21,
          discount: 0,
          line_type: {code: 'WORK'},
          line_type_code: 'WORK',
        },
      ])
    } else if (type === 'material') {
      setMaterialItems((prevState) => [
        ...prevState,
        {
          id: `NEW-MAT-${Math.random()}`,
          code: '',
          description: '',
          unit_price: 0,
          quantity: 0,
          tax: isSkProvider ? (hasSKNewDPH ? 23 : 20) : 21,
          discount: 0,
          line_type: {code: 'GOOD'},
          line_type_code: 'GOOD',
        },
      ])
    } else if (type === 'predefined') {
      setPredefinedItems((prevState) => [
        ...prevState,
        {
          id: `NEW-PRE-${Math.random()}`,
          code: '',
          description: '',
          unit_price: 0,
          quantity: 0,
          tax: isSkProvider ? (hasSKNewDPH ? 23 : 20) : 21,
          discount: 0,
          line_type: {code: 'PREDEFINED'},
          line_type_code: 'PREDEFINED',
        },
      ])
    }
  }

  //finish removing items, finish handle change of items
  const handleRemoveItem = (type, index, item) => () => {
    if (type === 'work') {
      setWorkItems((prevState) => prevState.filter((val) => val.id !== item.id))
    } else if (type === 'material') {
      setMaterialItems((prevState) => prevState.filter((val) => val.id !== item.id))
    } else if (type === 'predefined') {
      setPredefinedItems((prevState) => prevState.filter((val) => val.id !== item.id))
    }
  }

  const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve({file_content: reader.result, file_name: file.name})
      reader.onerror = (error) => reject(error)
    })
  }

  const handleAddFile = (e, type) => {
    e.preventDefault()
    const fileArray = [...document.querySelector('input[type="file"]').files]
    fileArray.forEach((file) => {
      uploadFile(file).then((res) => {
        setFileList((prevState) => [...prevState, {...res, type_id: type}])
      })
    })
  }

  const handleClickOnUploadButton = (e) => {
    e.preventDefault()
    const clickEvent = new MouseEvent('click', {bubbles: true})
    document.getElementById('file').dispatchEvent(clickEvent)
  }

  const handleRemoveFile = (rowIndex) => {
    setFileList((prevState) => [...prevState.filter((file, index) => index !== rowIndex)])
  }

  const fileColumns = [
    {
      name: 'file_name',
      label: <Trans>File name</Trans>,
    },
    {
      name: 'type_id',
      label: <Trans>File type</Trans>,
      render: (val) => attachmentTypes.filter((attachment) => attachment.id === val)?.[0]?.name,
    },
    {
      name: '',
      label: '',
      width: '40px',
      render: (val, row, rowIndex) => (
        <div onClick={() => handleRemoveFile(rowIndex)} className={classes.removeFile}>
          <Bin />
        </div>
      ),
    },
  ]

  const handleChangeCarField = (e) => {
    const name = e.target.name
    const value = e.target.value
    setCarFilters((prevState) => ({...prevState, [name]: value}))
  }

  const enterEventHandler = (e) => {
    if (e.key === 'Enter') {
      if (carFilters.vin || carFilters.rz) {
        getCar(carFilters)
          .then((res) => {
            setEditedValues((prevState) => ({
              ...prevState,
              vehicle: res.model_desc,
              car_id: res.id,
              ...res,
            }))
            getPredefinedTerms(res?.fleet_id)
          })
          .catch((err) => {
            setEditedValues((prevState) => ({...prevState, car_id: null}))
          })
          .finally(() => setCarFilters({}))
      }
      e.preventDefault()
    }
  }

  const dateEnterEventHandler = (formProps) => (e) => {
    if (e.key === 'Enter') {
      const value = e.target.value
      const name = e.target.name

      if (value) {
        let date = value?.split(' ')?.[0]

        const dateSeparator = date.includes('.')
          ? '.'
          : date.includes('/')
          ? '/'
          : date.includes('-')
          ? '-'
          : null

        if (date?.length > 2 && date?.split(dateSeparator)?.length > 2) {
          let newValueSplit = date?.split(dateSeparator)
          date = newValueSplit
            .map((val, index) => {
              if (newValueSplit?.length - index > 1) {
                if (val?.length === 1) {
                  return `0${val}`
                }
                // last number - year
              } else if (newValueSplit?.length - 1 === index) {
                let year = val
                while (year?.length === 2) {
                  year = moment()?.year().toString()?.slice(0, 2) + year
                }
                while (year?.length < 4) {
                  year += '0'
                }
                return year
              }
              return val
            })
            .join('.')
        }

        const dateTime = `${date ? date : ''}`

        formProps.form.change(name, moment(dateTime, DATE_FORMAT).format(DATE_FORMAT))

        if (name === 'date_issue') {
          formProps.form.change(
            'date_due',
            moment(value, DATE_FORMAT).add(30, 'days').format(DATE_FORMAT)
          )
          formProps.form.change('date_uzp', moment(value, DATE_FORMAT).format(DATE_FORMAT))

          setEditedValues((prevState) => ({
            ...prevState,
            date_issue: moment(value, DATE_FORMAT).format(DATE_FORMAT),
            date_due: moment(value, DATE_FORMAT).add(30, 'days').format(DATE_FORMAT),
            date_uzp: moment(value, DATE_FORMAT).format(DATE_FORMAT),
          }))
        }
      } else {
        formProps.form.change(name, moment().format(DATE_FORMAT))

        if (name === 'date_issue') {
          formProps.form.change('date_due', moment().add(30, 'days').format(DATE_FORMAT))
          formProps.form.change('date_uzp', moment().format(DATE_FORMAT))

          setEditedValues((prevState) => ({
            ...prevState,
            date_issue: moment().format(DATE_FORMAT),
            date_due: moment().add(30, 'days').format(DATE_FORMAT),
            date_uzp: moment().format(DATE_FORMAT),
          }))
        }
      }

      e.preventDefault()
    }
  }

  const checkPredefinedTerms = (fleetId) => {
    if (id === 'new') {
      if (fleetId || Number(fleetId) === 0) {
        return myFleets?.find((fleet) => fleet?.id === fleetId)?.has_predefined_terms
      }
    } else {
      return true
    }
  }

  const hasFieldTaxError = (dateIssue, tax) => {
    const hasSKNewDPH = dateIssue && moment(dateIssue, DATE_FORMAT).isAfter('2024-12-31')
    return hasSKNewDPH ? parseInt(tax, 10) === 20 : parseInt(tax, 10) === 23
  }

  const hasFormTaxError = (formValues) => {
    if (formValues) {
      const dateIssue = formValues.date_issue
      const hasSKNewDPH = dateIssue && moment(dateIssue, DATE_FORMAT).isAfter('2024-12-31')
      const items = [
        ...(formValues?.elitItem || []),
        ...(formValues?.oeItem || []),
        ...(formValues?.goodItem || []),
        ...(formValues?.workItem || []),
        ...(formValues?.predefinedItem || []),
      ]

      return hasSKNewDPH
        ? items.some((item) => parseInt(item.tax, 10) === 20)
        : items.some((item) => parseInt(item.tax, 10) === 23)
    }

    return false
  }

  useEffect(() => {
    if (id !== 'new') {
      getCfs(id)
        .then((res) => {
          setWorkItems(res?.items?.filter((item) => item?.line_type?.code === 'WORK'))
          setMaterialItems([
            ...res?.items?.filter((item) => item?.line_type?.code === 'GOOD'),
            ...res?.items?.filter((item) => item?.line_type?.code === 'ELIT'),
            ...res?.items?.filter((item) => item?.line_type?.code === 'OE'),
          ])
          setPredefinedItems(res?.items?.filter((item) => item?.line_type?.code === 'PREDEFINED'))

          if (res?.car?.fleet_id) {
            getPredefinedTerms(res?.car?.fleet_id)
          }
        })
        .catch((err) => {
          if (Array.isArray(err)) {
            err.forEach((error) => {
              if (error.status === 404) {
                redirectTo('/invoices')
              }
            })
          }
        })
    }
  }, [])

  useEffect(() => {
    getMySuppliers().catch(() => {})
    getMyFleets().catch(() => {})
    getAttachments().catch(() => {})
  }, [])

  useEffect(() => {
    document.getElementById('cfs-invoice')?.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
      }
    })
  }, [])

  const isDisabled = id === 'new' ? false : cfsLoading ? true : cfs?.status !== 3

  return (
    <div className={classes.detailPageContainer}>
      <Form onSubmit={handleSubmit} initialValues={getInitialValues}>
        {(formProps) => {
          return (
            <form onSubmit={formProps.handleSubmit} id={'cfs-invoice'}>
              {/* Pokud je faktura zamitnuta zobraz popis statusu */}
              {id !== 'new' && (cfs?.status === 3 || cfs.status === 1) && (
                <GridContainer alignItems="flex-start">
                  <GridItem container xs={12} alignItems="flex-start">
                    <BoxFullWidth pb={2} pt={0} className={classes.formTitle}>
                      <Trans>Status unprocessed</Trans>
                    </BoxFullWidth>
                  </GridItem>
                  <GridItem
                    container
                    xs={12}
                    alignItems={'flex-start'}
                    className={classes.statusDescriptionText}
                  >
                    <GridItem container xs={12}>
                      <Field
                        disabled={true}
                        name="status_description_copy"
                        label={<Trans>Description</Trans>}
                        component={TextInput}
                        multiline
                        rows={4}
                      />
                    </GridItem>
                  </GridItem>
                </GridContainer>
              )}
              <GridContainer alignItems="flex-start">
                <GridItem container xs={6} alignItems="flex-start">
                  <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                    <Trans>Car</Trans>
                  </BoxFullWidth>
                  <GridContainer
                    spacing={2}
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <GridItem container xs={12} sm={8}>
                      <Field
                        name="rz"
                        label={
                          <CustomTooltip title={<Trans>Press enter to search for car</Trans>}>
                            <span className={classes.tooltipLabel}>
                              <Trans>RZ</Trans>
                            </span>
                          </CustomTooltip>
                        }
                        component={TextInput}
                        onChange={(e) => {
                          handleChangeCarField(e, formProps?.values?.fleet_id)
                          handleFieldChange(e)
                        }}
                        validate={!!formProps.values.is_without_car ? undefined : required}
                        onKeyDown={enterEventHandler}
                        loading={carLoading}
                        disabled={carLoading || isDisabled}
                        fullWidth={false}
                        inLineInput={true}
                      />
                    </GridItem>

                    <GridItem container xs={12} sm={8}>
                      <Field
                        name="vin"
                        label={
                          <CustomTooltip title={<Trans>Press enter to search for car</Trans>}>
                            <span className={classes.tooltipLabel}>
                              <Trans>VIN</Trans>
                            </span>
                          </CustomTooltip>
                        }
                        component={TextInput}
                        onChange={(e) => {
                          handleChangeCarField(e, formProps?.values?.fleet_id)
                          handleFieldChange(e)
                        }}
                        validate={!!formProps.values.is_without_car ? undefined : validateVin}
                        onKeyDown={enterEventHandler}
                        loading={carLoading}
                        disabled={carLoading || isDisabled}
                        fullWidth={false}
                        inLineInput={true}
                      />
                    </GridItem>
                    <GridItem container xs={12} sm={8}>
                      <Field
                        name="clock"
                        label={<Trans>Mileage</Trans>}
                        component={TextInput}
                        loading={carLoading}
                        onChange={handleFieldChange}
                        disabled={carLoading || isDisabled}
                        fullWidth={false}
                        inLineInput={true}
                      />
                    </GridItem>
                    <GridItem container xs={12} sm={8}>
                      <Field
                        name="vehicle"
                        label={<Trans>Model</Trans>}
                        component={TextInput}
                        loading={carLoading}
                        onChange={handleFieldChange}
                        disabled={carLoading || isDisabled}
                        fullWidth={false}
                        inLineInput={true}
                      />
                    </GridItem>
                    <GridItem container xs={12} sm={8} className={classes.selectFlexFlowRow}>
                      <Field
                        name="fleet_id"
                        label={
                          <CustomTooltip
                            title={<Trans>Select fleet to fill final recipient</Trans>}
                          >
                            <span className={classes.tooltipLabel}>
                              <Trans>Fleet</Trans>
                            </span>
                          </CustomTooltip>
                        }
                        component={SelectInput}
                        options={myFleets?.map((fleet) => ({id: fleet.id, name: fleet.customer}))}
                        loading={myFleetsLoading}
                        onChange={handleFieldChange}
                        validate={required}
                        fullWidth={false}
                        inLineInput={true}
                        disabled={myFleetsLoading || isDisabled || editedValues.car_id}
                      />
                    </GridItem>
                    <GridItem container xs={12} sm={8}>
                      <Field
                        name="is_without_car"
                        label={<Trans>Without car</Trans>}
                        component={CheckBoxInput}
                        type={'checkbox'}
                        loading={carLoading}
                        disabled={carLoading || isDisabled}
                        onChange={handleFieldChange}
                        fullWidth={false}
                        inLineInput={true}
                      />
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem container xs={6} alignItems="flex-start">
                  <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                    <Trans>Supplier</Trans>
                  </BoxFullWidth>
                  <GridContainer
                    spacing={2}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <GridItem container xs={12} sm={6}>
                      <Field
                        name="supplier_customer_no"
                        label={<Trans>Customer number ELIT</Trans>}
                        component={TextInput}
                        disabled={true}
                      />
                    </GridItem>
                    <GridItem container xs={12} sm={6}>
                      <Field
                        name="supplier_ic"
                        label={<Trans>Supplier ICO</Trans>}
                        component={TextInput}
                        disabled={true}
                      />
                    </GridItem>

                    <BoxFullWidth py={2} pl={1} className={classes.formTitle}>
                      <Trans>Recipient/subscriber</Trans>
                    </BoxFullWidth>
                    <GridItem container xs={12} sm={6}>
                      <Field
                        name="provider.name"
                        label={<Trans>Subscriber</Trans>}
                        component={TextInput}
                        disabled={true}
                      />
                    </GridItem>
                    <GridItem container xs={12} sm={6}>
                      <Field
                        name="provider.ic"
                        label={<Trans>Subscriber ICO</Trans>}
                        component={TextInput}
                        disabled={true}
                      />
                    </GridItem>

                    <BoxFullWidth py={2} pl={1} className={classes.formTitle}>
                      <Trans>Final recipient</Trans>
                    </BoxFullWidth>
                    <GridItem container xs={12} sm={6}>
                      <div className={classes.staticFieldLabel}>
                        <Trans>Final recipient</Trans>
                      </div>
                      <div
                        className={cx(
                          classes.staticFieldDisabled,
                          classes.staticFieldBottomPadding
                        )}
                      >
                        {
                          myFleets?.find((fleet) => fleet?.id === formProps?.values?.fleet_id)
                            ?.customer
                        }
                      </div>
                    </GridItem>
                    <GridItem container xs={12} sm={6}>
                      <div className={classes.staticFieldLabel}>
                        <Trans>Final recipient ICO</Trans>
                      </div>
                      <div
                        className={cx(
                          classes.staticFieldDisabled,
                          classes.staticFieldBottomPadding
                        )}
                      >
                        {
                          myFleets?.find((fleet) => fleet?.id === formProps?.values?.fleet_id)
                            ?.customer_ic
                        }
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>

              <GridItem container xs={12}>
                <GridContainer
                  spacing={2}
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <BoxFullWidth p={2} pt={6} className={classes.formTitle}>
                    <Trans>Tax document</Trans>
                  </BoxFullWidth>
                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <Field
                        name="tax_document_no"
                        label={<Trans>Tax document number</Trans>}
                        component={TextInput}
                        validate={required}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                      />
                    </GridItem>
                    <GridItem xs={4} />
                    <GridItem container xs={4}>
                      <Field
                        name="confirmation_no"
                        label={<Trans>Confirmation number</Trans>}
                        component={TextInput}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                      />
                    </GridItem>
                  </GridItem>

                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <Field
                        name="date_issue"
                        label={
                          <CustomTooltip
                            title={
                              <Trans>
                                Press enter to format date and prefill due date and uzp date
                              </Trans>
                            }
                          >
                            <span className={classes.tooltipLabel}>
                              <Trans>Date issue</Trans>
                            </span>
                          </CustomTooltip>
                        }
                        component={TextInput}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                        onKeyDown={dateEnterEventHandler(formProps)}
                        validate={
                          isDisabled
                            ? undefined
                            : composeValidators(
                                minDate(formProps.values.date_uzp),
                                maxDate(moment()),
                                required
                              )
                        }
                      />
                    </GridItem>
                    <GridItem xs={4} />
                    <GridItem container xs={4}>
                      <Field
                        name="order_no"
                        label={<Trans>Order number</Trans>}
                        component={TextInput}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                      />
                    </GridItem>
                  </GridItem>

                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <Field
                        name="date_due"
                        label={
                          <CustomTooltip title={<Trans>Press enter to format date</Trans>}>
                            <span className={classes.tooltipLabel}>
                              <Trans>Due date</Trans>
                            </span>
                          </CustomTooltip>
                        }
                        component={TextInput}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                        onKeyDown={dateEnterEventHandler(formProps)}
                        validate={
                          isDisabled
                            ? undefined
                            : composeValidators(minDate(formProps.values.date_issue), required)
                        }
                      />
                    </GridItem>
                    <GridItem xs={4} />
                    <GridItem container xs={2}>
                      <Field
                        name="insured_event"
                        label={<Trans>Insured event</Trans>}
                        component={CheckBoxInput}
                        type={'checkbox'}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                      />
                    </GridItem>
                  </GridItem>

                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <Field
                        name="date_uzp"
                        label={
                          <CustomTooltip title={<Trans>Press enter to format date</Trans>}>
                            <span className={classes.tooltipLabel}>
                              <Trans>UZP date</Trans>
                            </span>
                          </CustomTooltip>
                        }
                        component={TextInput}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                        onKeyDown={dateEnterEventHandler(formProps)}
                        validate={
                          isDisabled ? undefined : composeValidators(maxDate(moment()), required)
                        }
                      />
                    </GridItem>
                    <GridItem xs={4} />
                    <GridItem container xs={2}>
                      <Field
                        name="loan_vehicle"
                        label={<Trans>NV</Trans>}
                        component={CheckBoxInput}
                        type={'checkbox'}
                        onChange={handleFieldChange}
                        disabled={isDisabled}
                        inLineInput={true}
                        fullWidth={false}
                      />
                    </GridItem>
                  </GridItem>
                </GridContainer>
              </GridItem>

              {/* PRACOVNI OPERACE */}
              <GridItem container xs={12}>
                <GridContainer direction="row" justifyContent="flex-start" alignItems="center">
                  <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                    <Trans>Work operations</Trans>
                  </BoxFullWidth>

                  <DetailTableHeader />

                  {workItems?.map((item, index) => {
                    const hasCustomError = hasFieldTaxError(
                      formProps.values.date_issue,
                      formProps.values.workItem?.[index]?.tax
                    )
                    return (
                      <GridContainer
                        key={`work-item-${index}`}
                        spacing={2}
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        className={classes.paddingBottomRow}
                      >
                        <GridItem container xs={12} sm={4} md={2} lg={2}>
                          {!isDisabled && focusedRow?.includes(`workItem.[${index}]`) ? (
                            <Field
                              name={`workItem.[${index}].code`}
                              component={TextInput}
                              showHelperText={false}
                              autoFocus={focusedRow === `workItem.[${index}].code`}
                              onChange={(e) => handleItemChange('work', index, e)}
                            />
                          ) : (
                            <div
                              className={classes.staticField}
                              onClick={() => handleSetFocusedRow(`workItem.[${[index]}].code`)}
                            >
                              {formProps.values?.workItem?.[index]?.code}
                            </div>
                          )}
                        </GridItem>
                        <GridItem container xs={12} sm={4} md={3}>
                          {!isDisabled && focusedRow?.includes(`workItem.[${index}]`) ? (
                            <Field
                              name={`workItem.[${index}].description`}
                              component={TextInput}
                              showHelperText={false}
                              autoFocus={focusedRow === `workItem.[${index}].description`}
                              onChange={(e) => handleItemChange('work', index, e)}
                            />
                          ) : (
                            <div
                              className={classes.staticField}
                              onClick={() =>
                                handleSetFocusedRow(`workItem.[${[index]}].description`)
                              }
                            >
                              {formProps.values?.workItem?.[index]?.description}
                            </div>
                          )}
                        </GridItem>
                        <GridItem container xs={12} sm={4} md={2}>
                          {!isDisabled && focusedRow?.includes(`workItem.[${index}]`) ? (
                            <Field
                              name={`workItem.[${index}].unit_price`}
                              component={TextInput}
                              showHelperText={false}
                              autoFocus={focusedRow === `workItem.[${index}].unit_price`}
                              onChange={(e) => handleItemChange('work', index, e)}
                              inputJustifyRight={true}
                              type={'number'}
                            />
                          ) : (
                            <div
                              className={cx(classes.staticField, classes.textAlignEnd)}
                              onClick={() =>
                                handleSetFocusedRow(`workItem.[${[index]}].unit_price`)
                              }
                            >
                              {formProps.values?.workItem?.[index]?.unit_price}
                            </div>
                          )}
                        </GridItem>
                        <GridItem container xs={12} sm={4} md={1} lg={1}>
                          {!isDisabled && focusedRow?.includes(`workItem.[${index}]`) ? (
                            <Field
                              name={`workItem.[${index}].quantity`}
                              component={TextInput}
                              showHelperText={false}
                              autoFocus={focusedRow === `workItem.[${index}].quantity`}
                              onChange={(e) => handleItemChange('work', index, e)}
                              inputJustifyRight={true}
                              type={'number'}
                            />
                          ) : (
                            <div
                              className={cx(classes.staticField, classes.textAlignEnd)}
                              onClick={() => handleSetFocusedRow(`workItem.[${[index]}].quantity`)}
                            >
                              {formProps.values?.workItem?.[index]?.quantity}
                            </div>
                          )}
                        </GridItem>
                        <GridItem container xs={12} sm={4} md={1} lg={1}>
                          {!isDisabled && focusedRow?.includes(`workItem.[${index}]`) ? (
                            <Field
                              name={`workItem.[${index}].tax`}
                              component={SelectInput}
                              options={isSkProvider ? SK_DPH : CZ_DPH}
                              showHelperText={false}
                              autoFocus={focusedRow === `workItem.[${index}].tax`}
                              onChange={(e) => handleItemChange('work', index, e)}
                              customError={hasCustomError}
                            />
                          ) : (
                            <div
                              className={cx(
                                classes.staticField,
                                hasCustomError ? classes.errorStaticField : ''
                              )}
                              onClick={() => handleSetFocusedRow(`workItem.[${[index]}].tax`)}
                            >
                              {formProps.values?.workItem?.[index]?.tax}
                            </div>
                          )}
                        </GridItem>
                        <GridItem container xs={12} sm={4} md={1} lg={1}>
                          {!isDisabled && focusedRow?.includes(`workItem.[${index}]`) ? (
                            <Field
                              name={`workItem.[${index}].discount`}
                              component={TextInput}
                              showHelperText={false}
                              autoFocus={focusedRow === `workItem.[${index}].discount`}
                              onChange={(e) => handleItemChange('work', index, e)}
                              inputJustifyRight={true}
                              type={'number'}
                            />
                          ) : (
                            <div
                              className={cx(classes.staticField, classes.textAlignEnd)}
                              onClick={() => handleSetFocusedRow(`workItem.[${[index]}].discount`)}
                            >
                              {formProps.values?.workItem?.[index]?.discount}
                            </div>
                          )}
                        </GridItem>
                        <GridItem container xs={12} sm={4} md={2} lg={2} alignItems={'center'}>
                          <GridItem xs={true}>
                            <div className={cx(classes.staticField, classes.textAlignEnd)}>
                              {getPriceWithoutTax(formProps?.values?.workItem?.[index])}
                            </div>
                          </GridItem>
                          {!isDisabled && (
                            <GridItem xs={'auto'}>
                              <IconButton
                                className={classes.removeItemButton}
                                onClick={handleRemoveItem('work', index, item)}
                              >
                                <Bin />
                              </IconButton>
                            </GridItem>
                          )}
                        </GridItem>
                      </GridContainer>
                    )
                  })}
                  {!isDisabled && (
                    <GridContainer
                      spacing={2}
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      className={classes.paddingBottomRow}
                    >
                      <GridItem
                        xs={12}
                        className={classes.addItemButton}
                        onClick={handleAddItem('work', formProps.values.date_issue)}
                      >
                        <Trans>Add work operation</Trans>
                      </GridItem>
                    </GridContainer>
                  )}
                </GridContainer>
              </GridItem>

              {/* MATERIAL */}
              <GridItem container xs={12}>
                <GridContainer direction="row" justifyContent="flex-start" alignItems="center">
                  <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                    <Trans>Material</Trans>
                  </BoxFullWidth>

                  <DetailTableHeader />

                  {materialItems
                    ?.filter(
                      (item) => item?.line_type?.code === 'GOOD' || item?.line_type_code === 'GOOD'
                    )
                    .map((item, index) => {
                      const hasCustomError = hasFieldTaxError(
                        formProps.values.date_issue,
                        formProps.values.goodItem?.[index]?.tax
                      )
                      return (
                        <GridContainer
                          key={`material-good-${index}`}
                          spacing={2}
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          className={classes.paddingBottomRow}
                        >
                          <GridItem container xs={12} sm={4} md={2} lg={2}>
                            {!isDisabled && focusedRow?.includes(`goodItem.[${index}]`) ? (
                              <Field
                                name={`goodItem.[${index}].code`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `goodItem.[${index}].code`}
                                onChange={(e) => handleItemChange('material', index, e, 'GOOD')}
                              />
                            ) : (
                              <div
                                className={classes.staticField}
                                onClick={() => handleSetFocusedRow(`goodItem.[${[index]}].code`)}
                              >
                                {formProps.values?.goodItem?.[index]?.code}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={3}>
                            {!isDisabled && focusedRow?.includes(`goodItem.[${index}]`) ? (
                              <Field
                                name={`goodItem.[${index}].description`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `goodItem.[${index}].description`}
                                onChange={(e) => handleItemChange('material', index, e, 'GOOD')}
                              />
                            ) : (
                              <div
                                className={classes.staticField}
                                onClick={() =>
                                  handleSetFocusedRow(`goodItem.[${[index]}].description`)
                                }
                              >
                                {formProps.values?.goodItem?.[index]?.description}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2}>
                            {!isDisabled && focusedRow?.includes(`goodItem.[${index}]`) ? (
                              <Field
                                name={`goodItem.[${index}].unit_price`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `goodItem.[${index}].unit_price`}
                                onChange={(e) => handleItemChange('material', index, e, 'GOOD')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`goodItem.[${[index]}].unit_price`)
                                }
                              >
                                {formProps.values?.goodItem?.[index]?.unit_price}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`goodItem.[${index}]`) ? (
                              <Field
                                name={`goodItem.[${index}].quantity`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `goodItem.[${index}].quantity`}
                                onChange={(e) => handleItemChange('material', index, e, 'GOOD')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`goodItem.[${[index]}].quantity`)
                                }
                              >
                                {formProps.values?.goodItem?.[index]?.quantity}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`goodItem.[${index}]`) ? (
                              <Field
                                name={`goodItem.[${index}].tax`}
                                component={SelectInput}
                                options={isSkProvider ? SK_DPH : CZ_DPH}
                                showHelperText={false}
                                autoFocus={focusedRow === `goodItem.[${index}].tax`}
                                onChange={(e) => handleItemChange('material', index, e, 'GOOD')}
                                customError={hasCustomError}
                              />
                            ) : (
                              <div
                                className={cx(
                                  classes.staticField,
                                  hasCustomError ? classes.errorStaticField : ''
                                )}
                                onClick={() => handleSetFocusedRow(`goodItem.[${[index]}].tax`)}
                              >
                                {formProps.values?.goodItem?.[index]?.tax}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`goodItem.[${index}]`) ? (
                              <Field
                                name={`goodItem.[${index}].discount`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `goodItem.[${index}].discount`}
                                onChange={(e) => handleItemChange('material', index, e, 'GOOD')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`goodItem.[${[index]}].discount`)
                                }
                              >
                                {formProps.values?.goodItem?.[index]?.discount}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2} lg={2} alignItems={'center'}>
                            <GridItem xs={true}>
                              <div className={cx(classes.staticField, classes.textAlignEnd)}>
                                {getPriceWithoutTax(formProps?.values?.goodItem?.[index])}
                              </div>
                            </GridItem>
                            {!isDisabled && (
                              <GridItem xs={'auto'}>
                                <IconButton
                                  className={classes.removeItemButton}
                                  onClick={handleRemoveItem('material', index, item)}
                                >
                                  <Bin />
                                </IconButton>
                              </GridItem>
                            )}
                          </GridItem>
                        </GridContainer>
                      )
                    })}

                  {materialItems
                    ?.filter(
                      (item) => item?.line_type?.code === 'ELIT' || item?.line_type_code === 'ELIT'
                    )
                    .map((item, index) => {
                      const hasCustomError = hasFieldTaxError(
                        formProps.values.date_issue,
                        formProps.values.elitItem?.[index]?.tax
                      )
                      return (
                        <GridContainer
                          key={`material-elit-${index}`}
                          spacing={2}
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          className={classes.paddingBottomRow}
                        >
                          <GridItem container xs={12} sm={4} md={2} lg={2}>
                            {!isDisabled && focusedRow?.includes(`elitItem.[${index}]`) ? (
                              <Field
                                name={`elitItem.[${index}].code`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `elitItem.[${index}].code`}
                                onChange={(e) => handleItemChange('material', index, e, 'ELIT')}
                              />
                            ) : (
                              <div
                                className={classes.staticField}
                                onClick={() => handleSetFocusedRow(`elitItem.[${[index]}].code`)}
                              >
                                {formProps.values?.elitItem?.[index]?.code}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={3}>
                            {!isDisabled && focusedRow?.includes(`elitItem.[${index}]`) ? (
                              <Field
                                name={`elitItem.[${index}].description`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `elitItem.[${index}].description`}
                                onChange={(e) => handleItemChange('material', index, e, 'ELIT')}
                              />
                            ) : (
                              <div
                                className={classes.staticField}
                                onClick={() =>
                                  handleSetFocusedRow(`elitItem.[${[index]}].description`)
                                }
                              >
                                {formProps.values?.elitItem?.[index]?.description}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2}>
                            {!isDisabled && focusedRow?.includes(`elitItem.[${index}]`) ? (
                              <Field
                                name={`elitItem.[${index}].unit_price`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `elitItem.[${index}].unit_price`}
                                onChange={(e) => handleItemChange('material', index, e, 'ELIT')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`elitItem.[${[index]}].unit_price`)
                                }
                              >
                                {formProps.values?.elitItem?.[index]?.unit_price}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`elitItem.[${index}]`) ? (
                              <Field
                                name={`elitItem.[${index}].quantity`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `elitItem.[${index}].quantity`}
                                onChange={(e) => handleItemChange('material', index, e, 'ELIT')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`elitItem.[${[index]}].quantity`)
                                }
                              >
                                {formProps.values?.elitItem?.[index]?.quantity}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`elitItem.[${index}]`) ? (
                              <Field
                                name={`elitItem.[${index}].tax`}
                                component={SelectInput}
                                options={isSkProvider ? SK_DPH : CZ_DPH}
                                showHelperText={false}
                                autoFocus={focusedRow === `elitItem.[${index}].tax`}
                                onChange={(e) => handleItemChange('material', index, e, 'ELIT')}
                                customError={hasCustomError}
                              />
                            ) : (
                              <div
                                className={cx(
                                  classes.staticField,
                                  hasCustomError ? classes.errorStaticField : ''
                                )}
                                onClick={() => handleSetFocusedRow(`elitItem.[${[index]}].tax`)}
                              >
                                {formProps.values?.elitItem?.[index]?.tax}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`elitItem.[${index}]`) ? (
                              <Field
                                name={`elitItem.[${index}].discount`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `elitItem.[${index}].discount`}
                                onChange={(e) => handleItemChange('material', index, e, 'ELIT')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`elitItem.[${[index]}].discount`)
                                }
                              >
                                {formProps.values?.elitItem?.[index]?.discount}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2} lg={2} alignItems={'center'}>
                            <GridItem xs={true}>
                              <div className={cx(classes.staticField, classes.textAlignEnd)}>
                                {getPriceWithoutTax(formProps?.values?.elitItem?.[index])}
                              </div>
                            </GridItem>
                            {!isDisabled && (
                              <GridItem xs={'auto'}>
                                <IconButton
                                  className={classes.removeItemButton}
                                  onClick={handleRemoveItem('material', index, item)}
                                >
                                  <Bin />
                                </IconButton>
                              </GridItem>
                            )}
                          </GridItem>
                        </GridContainer>
                      )
                    })}

                  {materialItems
                    ?.filter(
                      (item) => item?.line_type?.code === 'OE' || item?.line_type_code === 'OE'
                    )
                    .map((item, index) => {
                      const hasCustomError = hasFieldTaxError(
                        formProps.values.date_issue,
                        formProps.values.oeItem?.[index]?.tax
                      )
                      return (
                        <GridContainer
                          key={`material-oe-${index}`}
                          spacing={2}
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          className={classes.paddingBottomRow}
                        >
                          <GridItem container xs={12} sm={4} md={2} lg={2}>
                            {!isDisabled && focusedRow?.includes(`oeItem.[${index}]`) ? (
                              <Field
                                name={`oeItem.[${index}].code`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `oeItem.[${index}].code`}
                                onChange={(e) => handleItemChange('material', index, e, 'OE')}
                              />
                            ) : (
                              <div
                                className={classes.staticField}
                                onClick={() => handleSetFocusedRow(`oeItem.[${[index]}].code`)}
                              >
                                {formProps.values?.oeItem?.[index]?.code}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={3}>
                            {!isDisabled && focusedRow?.includes(`oeItem.[${index}]`) ? (
                              <Field
                                name={`oeItem.[${index}].description`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `oeItem.[${index}].description`}
                                onChange={(e) => handleItemChange('material', index, e, 'OE')}
                              />
                            ) : (
                              <div
                                className={classes.staticField}
                                onClick={() =>
                                  handleSetFocusedRow(`oeItem.[${[index]}].description`)
                                }
                              >
                                {formProps.values?.oeItem?.[index]?.description}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2}>
                            {!isDisabled && focusedRow?.includes(`oeItem.[${index}]`) ? (
                              <Field
                                name={`oeItem.[${index}].unit_price`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `oeItem.[${index}].unit_price`}
                                onChange={(e) => handleItemChange('material', index, e, 'OE')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`oeItem.[${[index]}].unit_price`)
                                }
                              >
                                {formProps.values?.oeItem?.[index]?.unit_price}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`oeItem.[${index}]`) ? (
                              <Field
                                name={`oeItem.[${index}].quantity`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `oeItem.[${index}].quantity`}
                                onChange={(e) => handleItemChange('material', index, e, 'OE')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() => handleSetFocusedRow(`oeItem.[${[index]}].quantity`)}
                              >
                                {formProps.values?.oeItem?.[index]?.quantity}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`oeItem.[${index}]`) ? (
                              <Field
                                name={`oeItem.[${index}].tax`}
                                component={SelectInput}
                                options={isSkProvider ? SK_DPH : CZ_DPH}
                                showHelperText={false}
                                autoFocus={focusedRow === `oeItem.[${index}].tax`}
                                onChange={(e) => handleItemChange('material', index, e, 'OE')}
                                customError={hasCustomError}
                              />
                            ) : (
                              <div
                                className={cx(
                                  classes.staticField,
                                  hasCustomError ? classes.errorStaticField : ''
                                )}
                                onClick={() => handleSetFocusedRow(`oeItem.[${[index]}].tax`)}
                              >
                                {formProps.values?.oeItem?.[index]?.tax}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`oeItem.[${index}]`) ? (
                              <Field
                                name={`oeItem.[${index}].discount`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `oeItem.[${index}].discount`}
                                onChange={(e) => handleItemChange('material', index, e, 'OE')}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() => handleSetFocusedRow(`oeItem.[${[index]}].discount`)}
                              >
                                {formProps.values?.oeItem?.[index]?.discount}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2} lg={2} alignItems={'center'}>
                            <GridItem xs={true}>
                              <div className={cx(classes.staticField, classes.textAlignEnd)}>
                                {getPriceWithoutTax(formProps?.values?.oeItem?.[index])}
                              </div>
                            </GridItem>
                            {!isDisabled && (
                              <GridItem xs={'auto'}>
                                <IconButton
                                  className={classes.removeItemButton}
                                  onClick={handleRemoveItem('material', index, item)}
                                >
                                  <Bin />
                                </IconButton>
                              </GridItem>
                            )}
                          </GridItem>
                        </GridContainer>
                      )
                    })}
                  {!isDisabled && (
                    <GridContainer
                      spacing={2}
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      className={classes.paddingBottomRow}
                    >
                      <GridItem
                        xs={12}
                        className={classes.addItemButton}
                        onClick={handleAddItem('material', formProps.values.date_issue)}
                      >
                        <Trans>Add material</Trans>
                      </GridItem>
                    </GridContainer>
                  )}
                </GridContainer>
              </GridItem>

              {/* VYBRANE PRACE */}
              {checkPredefinedTerms(formProps?.values?.fleet_id) && (
                <GridItem container xs={12}>
                  <GridContainer direction="row" justifyContent="flex-start" alignItems="center">
                    <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                      <Trans>Selected jobs</Trans>
                    </BoxFullWidth>

                    <DetailTableHeader />

                    {predefinedItems?.map((item, index) => {
                      const hasCustomError = hasFieldTaxError(
                        formProps.values.date_issue,
                        formProps.values.predefinedItem?.[index]?.tax
                      )
                      return (
                        <GridContainer
                          key={`predefined-item-${index}`}
                          spacing={2}
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          className={classes.paddingBottomRow}
                        >
                          <GridItem container xs={12} sm={4} md={2} lg={2}>
                            {/*{!isDisabled && focusedRow?.includes(`predefinedItem.[${index}]`) ? (*/}
                            {/*  <Field*/}
                            {/*    name={`predefinedItem.[${index}].code`}*/}
                            {/*    component={SelectInput}*/}
                            {/*    options={predefinedTerms.map((term) => ({*/}
                            {/*      value: term.code,*/}
                            {/*      name: term.code,*/}
                            {/*    }))}*/}
                            {/*    loading={predefinedTermsLoading}*/}
                            {/*    showHelperText={false}*/}
                            {/*    autoFocus={focusedRow === `predefinedItem.[${index}].code`}*/}
                            {/*    onChange={(e) => handleItemChange('predefined', index, e)}*/}
                            {/*  />*/}
                            {/*) : (*/}
                            <div
                              className={cx(classes.staticField, classes.staticFieldDisabled)}
                              onClick={() =>
                                handleSetFocusedRow(`predefinedItem.[${[index]}].code`)
                              }
                            >
                              {formProps.values?.predefinedItem?.[index]?.code}
                            </div>
                            {/*)}*/}
                          </GridItem>

                          <GridItem container xs={12} sm={4} md={3}>
                            {!isDisabled && focusedRow?.includes(`predefinedItem.[${index}]`) ? (
                              <Field
                                name={`predefinedItem.[${index}].description`}
                                component={SelectInput}
                                options={predefinedTerms?.map((term) => ({
                                  value: term?.description,
                                  name: term?.description,
                                }))}
                                loading={predefinedTermsLoading}
                                showHelperText={false}
                                autoFocus={focusedRow === `predefinedItem.[${index}].description`}
                                onChange={(e) => handleItemChange('predefined', index, e)}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField)}
                                onClick={() =>
                                  handleSetFocusedRow(`predefinedItem.[${[index]}].description`)
                                }
                              >
                                {formProps.values?.predefinedItem?.[index]?.description}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2}>
                            {/*{!isDisabled && focusedRow?.includes(`predefinedItem.[${index}]`) ? (*/}
                            {/*  <Field*/}
                            {/*    name={`predefinedItem.[${index}].unit_price`}*/}
                            {/*    component={TextInput}*/}
                            {/*    showHelperText={false}*/}
                            {/*    autoFocus={focusedRow === `predefinedItem.[${index}].unit_price`}*/}
                            {/*    onChange={(e) => handleItemChange('predefined', index, e)}*/}
                            {/*    inputJustifyRight={true}*/}
                            {/*    type={'number'}*/}
                            {/*  />*/}
                            {/*) : (*/}
                            <div
                              className={cx(
                                classes.staticField,
                                classes.textAlignEnd,
                                classes.staticFieldDisabled
                              )}
                              onClick={() =>
                                handleSetFocusedRow(`predefinedItem.[${[index]}].unit_price`)
                              }
                            >
                              {formProps.values?.predefinedItem?.[index]?.unit_price}
                            </div>
                            {/*)}*/}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`predefinedItem.[${index}]`) ? (
                              <Field
                                name={`predefinedItem.[${index}].quantity`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `predefinedItem.[${index}].quantity`}
                                onChange={(e) => handleItemChange('predefined', index, e)}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`predefinedItem.[${[index]}].quantity`)
                                }
                              >
                                {formProps.values?.predefinedItem?.[index]?.quantity}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`predefinedItem.[${index}]`) ? (
                              <Field
                                name={`predefinedItem.[${index}].tax`}
                                component={SelectInput}
                                options={isSkProvider ? SK_DPH : CZ_DPH}
                                showHelperText={false}
                                autoFocus={focusedRow === `predefinedItem.[${index}].tax`}
                                onChange={(e) => handleItemChange('predefined', index, e)}
                                customError={hasCustomError}
                              />
                            ) : (
                              <div
                                className={cx(
                                  classes.staticField,
                                  hasCustomError ? classes.errorStaticField : ''
                                )}
                                onClick={() =>
                                  handleSetFocusedRow(`predefinedItem.[${[index]}].tax`)
                                }
                              >
                                {formProps.values?.predefinedItem?.[index]?.tax}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={1} lg={1}>
                            {!isDisabled && focusedRow?.includes(`predefinedItem.[${index}]`) ? (
                              <Field
                                name={`predefinedItem.[${index}].discount`}
                                component={TextInput}
                                showHelperText={false}
                                autoFocus={focusedRow === `predefinedItem.[${index}].discount`}
                                onChange={(e) => handleItemChange('predefined', index, e)}
                                inputJustifyRight={true}
                                type={'number'}
                              />
                            ) : (
                              <div
                                className={cx(classes.staticField, classes.textAlignEnd)}
                                onClick={() =>
                                  handleSetFocusedRow(`predefinedItem.[${[index]}].discount`)
                                }
                              >
                                {formProps.values?.predefinedItem?.[index]?.discount}
                              </div>
                            )}
                          </GridItem>
                          <GridItem container xs={12} sm={4} md={2} lg={2} alignItems={'center'}>
                            <GridItem xs={true}>
                              <div
                                className={cx(
                                  classes.staticField,
                                  classes.staticFieldDisabled,
                                  classes.textAlignEnd
                                )}
                              >
                                {getPriceWithoutTax(formProps?.values?.predefinedItem?.[index])}
                              </div>
                            </GridItem>
                            {!isDisabled && (
                              <GridItem xs={'auto'}>
                                <IconButton
                                  className={classes.removeItemButton}
                                  onClick={handleRemoveItem('predefined', index, item)}
                                >
                                  <Bin />
                                </IconButton>
                              </GridItem>
                            )}
                          </GridItem>
                        </GridContainer>
                      )
                    })}
                    {!isDisabled && (
                      <GridContainer
                        spacing={2}
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        className={classes.paddingBottomRow}
                      >
                        <GridItem
                          xs={12}
                          className={classes.addItemButton}
                          onClick={handleAddItem('predefined', formProps.values.date_issue)}
                        >
                          <Trans>Add selected job</Trans>
                        </GridItem>
                      </GridContainer>
                    )}
                  </GridContainer>
                </GridItem>
              )}

              <GridItem container xs={12}>
                <GridContainer
                  spacing={2}
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <BoxFullWidth p={2} pt={6} className={classes.formTitle}>
                    <Trans>Summary</Trans>
                  </BoxFullWidth>
                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <TextInput
                        disabled={true}
                        showHelperText={false}
                        label={<Trans>Total without tax</Trans>}
                        value={Math.round(getTotal(formProps?.values, false) * 100) / 100}
                        inLineInput={true}
                        fullWidth={false}
                        noInlineFlex={true}
                      />
                    </GridItem>
                  </GridItem>
                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <TextInput
                        disabled={true}
                        showHelperText={false}
                        label={<Trans>Total tax</Trans>}
                        value={
                          Math.round(
                            Number(
                              getTotal(formProps?.values, true) -
                                Number(getTotal(formProps?.values, false))
                            ) * 100
                          ) / 100
                        }
                        inLineInput={true}
                        fullWidth={false}
                        noInlineFlex={true}
                      />
                    </GridItem>
                  </GridItem>
                  <GridItem container xs={12}>
                    <GridItem container xs={4}>
                      <TextInput
                        disabled={true}
                        showHelperText={false}
                        label={<Trans>Total with tax</Trans>}
                        value={Math.round(getTotal(formProps?.values, true) * 100) / 100}
                        inLineInput={true}
                        fullWidth={false}
                        noInlineFlex={true}
                      />
                    </GridItem>
                  </GridItem>
                </GridContainer>
              </GridItem>

              {!isDisabled && (
                <GridItem container xs={12}>
                  <GridContainer
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                  >
                    <GridItem xs={12} sm={6}>
                      <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                        <Trans>Add attachment</Trans>
                      </BoxFullWidth>
                      <GridContainer justifyContent="space-between">
                        <GridItem xs={8} className={classes.alignLeft}>
                          <Field
                            name="type_id"
                            label={<Trans>File type</Trans>}
                            component={SelectInput}
                            options={attachmentTypes}
                            loading={attachmentTypesLoading}
                            emptyOption={true}
                          />
                        </GridItem>
                        <GridItem xs={4} className={cx(classes.buttonAndTable, classes.alignLeft)}>
                          <PrimaryButton
                            textPadding={0}
                            fullWidth={false}
                            size={'large'}
                            id={'file-button'}
                            disabled={!formProps?.values?.type_id}
                            onClick={formProps?.values?.type_id && handleClickOnUploadButton}
                            text={<Trans>Upload</Trans>}
                          />
                          <input
                            style={{display: 'none'}}
                            type="file"
                            id="file"
                            name="attachment"
                            multiple={formProps?.values?.type_id === 13}
                            onChange={(e) => handleAddFile(e, formProps?.values?.type_id)}
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>

                    <GridItem xs={12} sm={6} className={classes.attachmentTablePadding}>
                      <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                        <Trans>New attachments</Trans>
                      </BoxFullWidth>
                      <GridItem container xs={12} className={classes.overflowAuto}>
                        <Table
                          data={fileList}
                          columns={fileColumns}
                          pagination={false}
                          className={cx(classes.lastRowRoundBorder, classes.detailTable)}
                        />
                      </GridItem>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              )}

              {id !== 'new' && (
                <GridItem container xs={12}>
                  {/* LAST ATTACHMENTS */}
                  <GridItem xs={6} className={classes.attachmentTablePadding}>
                    <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                      <Trans>Last attachments</Trans>
                    </BoxFullWidth>
                    <GridItem container xs={12} className={classes.overflowAuto}>
                      <Table
                        data={cfs?.attachments?.filter((att) => att.actual)}
                        columns={attachmentColumns}
                        loading={cfsLoading}
                        pagination={false}
                        className={cx(classes.lastRowRoundBorder, classes.detailTable)}
                      />
                    </GridItem>
                  </GridItem>

                  {/* ORIGINAL ATTACHMENTS */}
                  <GridItem xs={6} className={classes.attachmentTablePadding}>
                    <BoxFullWidth pb={2} pt={6} className={classes.formTitle}>
                      <Trans>Original attachments</Trans>
                    </BoxFullWidth>
                    <GridItem container xs={12} className={classes.overflowAuto}>
                      <Table
                        data={cfs?.attachments?.filter((att) => !att.actual)}
                        columns={attachmentColumns}
                        loading={cfsLoading}
                        pagination={false}
                        className={cx(classes.lastRowRoundBorder, classes.detailTable)}
                      />
                    </GridItem>
                  </GridItem>
                </GridItem>
              )}

              {(!isDisabled || cfs.status === 1) && (
                <>
                  <GridContainer
                    spacing={2}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <BoxFullWidth px={2} pt={8} className={classes.formTitle}>
                      <Trans>Message for processors:</Trans>
                    </BoxFullWidth>
                    <GridItem container xs={6} className={classes.statusDescription}>
                      <Field
                        disabled={formProps.submitting}
                        name="new_status_description"
                        component={TextInput}
                        onChange={handleFieldChange}
                        multiline
                        rows={4}
                      />
                    </GridItem>
                  </GridContainer>

                  <BoxFullWidth pt={6}>
                    <GridItem container xs={12}>
                      <GridContainer
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <PrimaryButton
                          size={'large'}
                          fullWidth={false}
                          textPadding={0}
                          text={<Trans>Save</Trans>}
                          disabled={formProps.submitting || hasFormTaxError(formProps.values)}
                          id={'submit-button'}
                          type={'submit'}
                        />
                      </GridContainer>
                    </GridItem>
                  </BoxFullWidth>
                </>
              )}
            </form>
          )
        }}
      </Form>
    </div>
  )
}

CFSDetail.propTypes = {
  classes: PropTypes.object,
  getCfs: PropTypes.func,
  cfs: PropTypes.object,
  cfsLoading: PropTypes.bool,
  patchCfs: PropTypes.func,
  createCfs: PropTypes.func,
  getMySuppliers: PropTypes.func,
  mySupplier: PropTypes.object,
  mySupplierLoading: PropTypes.bool,
  getMyFleets: PropTypes.func,
  myFleets: PropTypes.array,
  myFleetsLoading: PropTypes.bool,
  myFleetsMeta: PropTypes.object,
  getCar: PropTypes.func,
  car: PropTypes.object,
  carLoading: PropTypes.bool,
  getAttachments: PropTypes.func,
  attachmentTypesLoading: PropTypes.bool,
  attachmentTypes: PropTypes.array,
  attachmentTypesMeta: PropTypes.object,
  getPredefinedTerms: PropTypes.func,
  predefinedTerms: PropTypes.array,
  predefinedTermsMeta: PropTypes.object,
  predefinedTermsLoading: PropTypes.bool,
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCfs,
      patchCfs,
      createCfs,
      getMySuppliers,
      getMyFleets,
      getCar,
      getAttachments,
      getPredefinedTerms,
    },
    dispatch
  )
}

export default compose(
  withStyles(detailPageStyle),
  connect((store) => {
    return {
      cfs: store.cfs.cfs,
      cfsLoading: store.cfs.cfsLoading,
      mySupplier: store.cfs.mySupplier,
      mySupplierLoading: store.cfs.mySupplierLoading,
      myFleets: store.cfs.myFleets,
      myFleetsLoading: store.cfs.myFleetsLoading,
      myFleetsMeta: store.cfs.myFleetsMeta,
      car: store.cfs.car,
      carLoading: store.cfs.carLoading,
      attachmentTypesLoading: store.cfs.attachmentTypesLoading,
      attachmentTypes: store.cfs.attachmentTypes,
      attachmentTypesMeta: store.cfs.attachmentTypesMeta,
      predefinedTerms: store.cfs.predefinedTerms,
      predefinedTermsMeta: store.cfs.predefinedTermsMeta,
      predefinedTermsLoading: store.cfs.predefinedTermsLoading,
    }
  }, mapDispatchToProps)
)(CFSDetail)
